<template>
  <div>
    <h4>
      <b-badge :variant="statusConfig.variant">
        {{ $t("status") }} - {{ $t(statusConfig.label) }}
      </b-badge>
    </h4>
  </div>
</template>

<script>
export default {
  name: "InvoiceStatus",
  props: {
    status: {
      type: Number,
      required: true
    },
    invoice: {
      type: Object,
      default: () => ({})
    }
  },
  computed: {
    statusConfig() {
      const configs = {
        0: { variant: "success", label: "Open" },
        1: { variant: "success", label: "active_marketplace_offer" },
        2: { variant: "danger", label: "rejected" },
        3: { variant: "secondary", label: "scoring_required" },
        4: { variant: "success", label: "scored" },
        5: { variant: "warning", label: "click_sell_invoice" },
        6: { variant: "warning", label: this.invoice?.is_reverse === 1 ? "supplier_confirmation_required" : "debtor_confirmation_required" },
        7: { variant: "danger", label: "rejected" },
        8: { variant: "success", label: "soon_goes_active" },
        9: { variant: "success", label: "in_review" },
        10: { variant: "success", label: "sold" },
        11: { variant: "success", label: "settled" },
        13: { variant: "danger", label: "invoice_default" },
        14: { variant: "danger", label: "deactivated" },
        15: { variant: "warning", label: "removed_from_marketplace" },
        16: { variant: "warning", label: this.invoice?.purchase_confirmed === 1 ? "pending_admin_approval" : "required_seller_confirmation" },
        99: { variant: "danger", label: "removed" }
      };

      return configs[this.status] || { variant: "success", label: "send_offer" };
    }
  }
};
</script>

<style scoped>
</style>
